export default (id, file) => {
  return `
    <div id="direct-upload-${id}" class="direct-upload direct-upload--pending">
      <div id="direct-upload-progress-${id}" class="direct-upload__progress"></div>
    </div>
  `
}
